var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sup',[_c('i',{staticClass:"bi bi-key-fill ms-1",class:['text-' + _vm.iconColour]})])
}
var staticRenderFns = []

export { render, staticRenderFns }